import { clearReportFilter } from '../../redux/slices/reportfilterSlice';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

const useClearFilters = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearReportFilter());
    };
  }, [dispatch]);
};

export default useClearFilters;
